import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "ProductInventoryPrice",
    initialState: {
        master_data: {},
        inventory_list: {},
        pricing_list: {}
    },
    reducers: {
        setInventory: {
            reducer: (state, action) => {
                state.inventory_list = action.payload
            },
        },
        setPricingList: {
            reducer: (state, action) => {
                state.pricing_list = action.payload
            },
        },
    },
    extraReducers: {},
});

export let { setInventory, setPricingList } = slice.actions;

export default slice.reducer;
